export class DatahubService {
    static async getDatahubLayers(datahubUrl) {
        const datahubData = await (await fetch(datahubUrl + '/rest')).json();
        return datahubData.map((data) => {
            const layer = data;
            layer.fields = data.fields;
            return layer;
        });
    }
    static async getDatahubLayer(datahubUrl, datahubSelection) {
        const datahubData = await (await fetch(`${datahubUrl}/rest/${datahubSelection.theme}/${datahubSelection.layer}`)).json();
        // remove unused properties
        delete datahubData.materializeView;
        delete datahubData.query;
        delete datahubData.tableName;
        delete datahubData.newTheme;
        delete datahubData.zindex;
        const layer = datahubData;
        layer.fields = datahubData.fields.map((field) => {
            return { name: field.name, alias: field.shortAlias, type: field.type };
        });
        return layer;
    }
    static async datahubSelectionToDatahubLayer(datahubUrl, selection) {
        if (!selection.layer)
            throw new Error('Layer is required');
        const layer = await this.getDatahubLayer(datahubUrl, selection);
        layer.fields = layer.fields.filter((field) => selection.fields.includes(field.name));
        return layer;
    }
    static datahubLayerToDatahubSelection(datahubUrl, datahubLayer) {
        const selection = JSON.parse(JSON.stringify(datahubLayer));
        selection.dataId = datahubLayer.name;
        selection.layer = datahubLayer.name;
        selection.fields = datahubLayer.fields.map((field) => field.name);
        return selection;
    }
}
